import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import BackButton from '../../components/atoms/BackButton';
import ChangeButton from '../../components/atoms/ChangeButton';

const styles = {
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    outline: 'none'
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px'
  },
  detailTable: {
    width: 'auto'
  },
  tableCellItem: {
    border: '2px solid #ffffff',
    backgroundColor: '#e0e0e0'
  },
  tableCellData: {
    border: '2px solid #ffffff'
  }
};

const enhance = compose();

const Main = enhance(({ classes, backAction, unusedAction, params }) => {
  return (
    <div className={classes.root}>
      <Typography variant="h6">こどもごちめし未使用</Typography>
      <Paper className={classes.mainPaper} elevation={1}>
        <Table className={classes.detailTable}>
          <TableRow>
            <TableCell className={classes.tableCellItem}>
              次回利用可能日
            </TableCell>
            <TableCell className={classes.tableCellData}>
              {params.canUseDate}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>事前利用額</TableCell>
            <TableCell className={classes.tableCellData}>
              {params.preUseAmount}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>
              事前利用回数
            </TableCell>
            <TableCell className={classes.tableCellData}>
              {params.preUseCount}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>充当額</TableCell>
            <TableCell className={classes.tableCellData}>
              {params.debtAmount}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={classes.tableCellItem}>事前利用日</TableCell>
            <TableCell className={classes.tableCellData}>
              {params.preUseDate}
            </TableCell>
          </TableRow>
        </Table>
      </Paper>
      <div>
        <BackButton onClickAction={backAction} />
        <ChangeButton onClickAction={unusedAction} btnText="確定" />
      </div>
    </div>
  );
});

export default withRouter(withStyles(styles)(Main));
